import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentExpertBlockSet, EPostContentExpertBlockActionType } from './types';
import { IPostContentExpertBlock } from '../../types/postContentExpertBlocks';

export const postContentExpertBlockSet: (data: IPostContentExpertBlock) => TPostContentExpertBlockSet = actionGenerator<
  EPostContentExpertBlockActionType.Set,
  IPostContentExpertBlock
>(EPostContentExpertBlockActionType.Set);
